import React, { useEffect, useState } from 'react';
import Badges from '../../../Components/Students/Badges';
import styles from './PortFolio.module.css';
import Elon_Musk from '../../../Assets/Elon_Musk.jpg';
import Upload from '../../../Assets/Upload.svg';
import Rectangle1 from '../../../Assets/Rectangle1.svg';
import Rectangle2 from '../../../Assets/Rectangle2.svg';
import Rectangle3 from '../../../Assets/Rectangle3.svg';
import Rectangle4 from '../../../Assets/Rectangle4.svg';
import Uploadsymbol from '../../../Assets/Uploadsymbol.svg';
import download from '../../../Assets/download.svg';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { studentActions } from '../../../redux/actions';
import * as api from '../../../services/api';
import Navbar from '../../../Components/Students/Navbar/Navbar';
import Swal from 'sweetalert2';
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import { ModelViewer } from '../../../Components/ModalViewer/ModalViewer';

const PortFolio = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [portfolio, setPortfolio] = useState([]);
  const [modalOpen, setModalOpen] = useState({
    open: false,
    url: '',
    type: '',
  });
  const dispatch = useDispatch();
  const students = useSelector((state) => state.student);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user._id;
    dispatch(studentActions.setStudent(userId));
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      const data = await api.getUpdatedPortfolio();
      setPortfolio(data.data.data);
    };

    fetchData();
  }, []);
  const uploadFile = (selectedFile) => {
    const { type, name, size } = selectedFile;
    // Displaying name and type of file for verification
    // console.log('Name: ', name, 'Type:', type, 'Size: ', size);
    // setFileAsset(selectedFile);
    // Check type and use any suitable upload logic as per your backend system here.
    const formData = new FormData();
    formData.append('file', selectedFile);
    api.uploadResume(formData).then((res) => {
      if (res.status === 201) {
        Swal.fire({
          icon: 'success',
          text: 'Resume uploaded successfully!',
          timer: 1300,
        });
      }
    });
  };
  const uploadHandler = (e) => {
    e.preventDefault();
    const selectedFile = e.target.files[0];
    const fileSize = selectedFile.size;
    const fileSizeMb = fileSize / 1024 ** 2;

    if (fileSizeMb < 5) {
      const allowedExtensions = /(\.pdf)$/i;
      if (!allowedExtensions.exec(selectedFile?.name)) {
        // Swal.fire("Please upload pdf file only...");
        Swal.fire({
          icon: 'warning',
          text: 'Please upload pdf file only...',
          timer: 1300,
        });
        return;
      }
      uploadFile(selectedFile);
    } else {
      Swal.fire({
        icon: 'warning',
        text: 'File size should be less than 5MB',
        timer: 1300,
      });
    }
  };

  const imageViewer = (url, type) => {
    setModalOpen({
      open: true,
      url: url,
      type: type,
    });
  };

  if (!students) {
    return (
      <div className={styles.container}>
        <div>Loading...</div>
      </div>
    );
  }
  const statusMap = {
    open_for_work: 'Open for Work',
    browsing: 'Browsing',
    not_looking: 'Not Looking',
  };

  const downloadHandler = (url) => {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      link.href = url;
      const isImage =
        url.includes('jpg') ||
        url.includes('png') ||
        url.includes('jpeg') ||
        url.includes('gif');
      if (isImage) {
        link.download = url.substring(url.lastIndexOf('/') + 1, url.length);
        link.target = '_blank';
      }
      link.download = url.substring(url.lastIndexOf('/') + 1, url.length);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <>
      <Modal
        size='xl'
        isOpen={modalOpen.open}
        onClose={() =>
          setModalOpen({
            open: false,
            url: '',
            type: '',
          })
        }
      >
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton zIndex={99} />
          <ModalBody>
            {modalOpen.type === 'glb' ? (
              <ModelViewer url={modalOpen.url} />
            ) : (
              <img
                src={modalOpen.url}
                alt='portfolio'
                className={styles.modalImage}
              />
            )}

            <div onClick={() => downloadHandler(modalOpen.url)}>
              <p className={styles.Upload_work}>
                <span>
                  <img src={download} />
                </span>{' '}
                Download
              </p>
            </div>
            {/* <Lorem count={2} /> */}
          </ModalBody>
        </ModalContent>
      </Modal>
      <div className={styles.container}>
        <div className={styles.profile}>
          <div className={styles.imgContainer}>
            <div className={styles.imgWrapper}>
              <img
                src={students?.profilePhoto}
                alt='student'
                className={styles.user_profile}
              />
            </div>
          </div>
          <div className={styles.username}>{students?.name}</div>
          <p className={styles.student}>ACP Student</p>
          {/* ********* */}
          <div className={styles.Open_for_work}>
            <p>{statusMap[students?.student_status]}</p>
          </div>
          {/* ********* */}
          <Link to='/hiring/student/StartBuildingProject'>
            <div>
              <p className={styles.Upload_work}>
                <span>+</span> Upload work
              </p>
            </div>
          </Link>
          {/* Badges */}
          {students?.badges?.length > 0 && (
            <div className={styles.Badges} style={{ marginTop: '5px' }}>
              <p style={{ marginBottom: '12px' }}>Badges</p>
              <div className={styles.courses}>
                {students?.badges?.map((badge, idx) => (
                  <Badges key={'badges' + idx} badges={badge} />
                ))}
              </div>
            </div>
          )}
          {/* Bio */}
          {students?.bio && (
            <div className={styles.Bio}>
              <p>Bio</p>
              <div className={styles.Bio_desc}>
                <p>{students?.bio}</p>
              </div>
            </div>
          )}
          {/* Resume */}
          <label className={styles.resume_container}>
            <input
              type='file'
              accept='.pdf'
              style={{ width: '100%', height: '100%' }}
              onChange={uploadHandler}
              hidden
            />
            <div>
              <img src={Uploadsymbol} alt='' />
            </div>
            <div className={styles.resumeUpload}>Upload Resume</div>
          </label>
        </div>
        {/* Project videos */}
        <div className={styles.projectvideoCont}>
          <div className={styles.project_videos}>
            {portfolio?.map((item, idx) => {
              // console.log(item)
              const youtubeRegex =
                /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;
              const imageRegex = /^(https?\:\/\/)?(img\.nftically).+$/i;
              const localImgRegex = /\.(jpeg|jpg|png|gif)$/i;
              const localVideoRegex = /\.(mp4|webm)$/i;
              function isValidURL() {
                if (youtubeRegex.test(item.url)) {
                  {
                    /* console.log('valid youtube video' + item); */
                  }
                  return 'y';
                } else if (imageRegex.test(item.url)) {
                  return 'i';
                } else if (localImgRegex.test(item.url)) {
                  return 'i';
                } else if (localVideoRegex.test(item.url)) {
                  return 'v';
                }
              }
              isValidURL();
              if (isValidURL() === 'i') {
                return (
                  <div key={idx} className={styles.projectBadges}>
                    <div className={styles.projectsimages}>
                      <img src={item.url} />
                      <div
                        className={styles.middle}
                        onClick={() => {
                          imageViewer(item.fileURL, 'glb');
                        }}
                      >
                        <div className={styles.text}>View</div>
                      </div>
                      {/* <div className={styles.projectname_badges}>
                  <div className={styles.projectname}>Project name</div>
                  <div className={styles.badges}>NFT</div>
                </div> */}
                    </div>
                  </div>
                );
              } else {
                if (isValidURL() === 'y') {
                  const urlArr = item?.url?.split('/');
                  const lastItem = urlArr[urlArr.length - 1];
                  let videoId;

                  if (lastItem.includes('watch')) {
                    const lastItemArr = lastItem.split('=');
                    const id = lastItemArr[lastItemArr.length - 1];
                    videoId = id;
                  } else {
                    videoId = lastItem;
                  }
                  return (
                    <div key={idx} className={styles.projectBadges}>
                      <div className={styles.youtubevideo}>
                        <a
                          href={item.url}
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {/* <iframe
                            src={`http://youtube.com/vi/${videoId}/maxresdefault`}
                            alt='you tube video thumbnail'
                          controls/> */}
                          <iframe
                            height={200}
                            src={`https://www.youtube.com/embed/${videoId}`}
                            title='YouTube video player'
                            frameborder='0'
                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                            allowfullscreen
                          ></iframe>
                        </a>

                        {/* {console.log('urllink', item.url)} */}
                        {/* <div className={styles.projectname_badges}>
                        <div className={styles.projectname}>{item.title}</div>
                        <div className={styles.badges}>{item.type}</div>
                      </div> */}
                      </div>
                    </div>
                  );
                }
                if (isValidURL() === 'i') {
                  return (
                    <div key={idx} className={styles.projectBadges}>
                      <div className={styles.projectsimages}>
                        <img src={item.url} alt={item.title} />
                        <div
                          className={styles.middle}
                          onClick={() => {
                            imageViewer(item.fileURL, 'glb');
                          }}
                        >
                          <div className={styles.text}>View</div>
                        </div>
                        {/* {console.log('urllink', item.url)} */}
                        <div className={styles.projectname_badges}>
                          <div className={styles.projectname}>{item.title}</div>
                          <div className={styles.badges}>{item.type}</div>
                        </div>
                      </div>
                    </div>
                  );
                }
                if (isValidURL() === 'v') {
                  return (
                    <div key={idx} className={styles.projectBadges}>
                      <div className={styles.projectvideo}>
                        <video src={item.url} alt={item.title} controls />

                        {/* {console.log('urllink', item.url)} */}
                        <div className={styles.projectname_badges}>
                          <div className={styles.projectname}>{item.title}</div>
                          <div className={styles.badges}>{item.type}</div>
                        </div>
                      </div>
                    </div>
                  );
                }
              }
            })}
            {/* ************ */}
            {students?.uploaded?.length === 0 ? (
              <div>No Work to Show</div>
            ) : (
              students?.uploaded?.map((item, idx) => {
                const youtubeRegex =
                  /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;
                const imageRegex = /^(https?\:\/\/)?(img\.nftically).+$/i;
                const localImgRegex = /\.(jpeg|jpg|png|gif)$/i;
                const localVideoRegex = /\.(mp4|webm)$/i;
                function isValidURL() {
                  if (youtubeRegex.test(item.url)) {
                    {
                      /* console.log('valid youtube video' + item); */
                    }
                    return 'y';
                  } else if (imageRegex.test(item)) {
                    {
                      /* console.log('valid image' + item); */
                    }
                    return 'n';
                  } else if (localImgRegex.test(item.url)) {
                    {
                      /* console.log('localImage is valid'); */
                    }
                    return 'i';
                  } else if (localVideoRegex.test(item.url)) {
                    return 'v';
                  }
                }
                isValidURL();
                if (typeof item === 'string') {
                  return (
                    <div key={idx} className={styles.projectBadges}>
                      <div className={styles.projectsimages}>
                        <img src={item} />
                      </div>
                    </div>
                  );
                } else {
                  if (isValidURL() === 'y') {
                    const urlArr = item?.url?.split('/');
                    const lastItem = urlArr[urlArr.length - 1];
                    let videoId;
                    if (lastItem.includes('watch')) {
                      const lastItemArr = lastItem.split('=');
                      const id = lastItemArr[lastItemArr.length - 1];
                      videoId = id;
                    } else {
                      videoId = lastItem;
                    }
                    return (
                      <div key={idx} className={styles.projectBadges}>
                        <div className={styles.youtubevideo}>
                          <a
                            href={item.url}
                            target='_blank'
                            rel='noopener noreferrer'
                          >
                            {/* <iframe
                            src={`http://youtube.com/vi/${videoId}/maxresdefault`}
                            alt='you tube video thumbnail'
                          controls/> */}
                            <iframe
                              height={200}
                              src={`https://www.youtube.com/embed/${videoId}`}
                              title='YouTube video player'
                              frameborder='0'
                              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                              allowfullscreen
                            ></iframe>
                          </a>

                          {/* {console.log('urllink', item.url)} */}
                          {/* <div className={styles.projectname_badges}>
                        <div className={styles.projectname}>{item.title}</div>
                        <div className={styles.badges}>{item.type}</div>
                      </div> */}
                        </div>
                      </div>
                    );
                  }
                  if (isValidURL() === 'i') {
                    return (
                      <div key={idx} className={styles.projectBadges}>
                        <div className={styles.projectsimages}>
                          <img src={item.url} alt={item.title} />
                          <div
                            className={styles.middle}
                            onClick={() => {
                              imageViewer(item.url, 'img');
                            }}
                          >
                            <div className={styles.text}>View</div>
                          </div>
                          {/* {console.log('urllink', item.url)} */}
                          <div className={styles.projectname_badges}>
                            <div className={styles.projectname}>
                              {item.title}
                            </div>
                            <div className={styles.badges}>{item.type}</div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                  if (isValidURL() === 'v') {
                    return (
                      <div key={idx} className={styles.projectBadges}>
                        <div className={styles.projectvideo}>
                          <video src={item.url} alt={item.title} controls />

                          {/* {console.log('urllink', item.url)} */}
                          <div className={styles.projectname_badges}>
                            <div className={styles.projectname}>
                              {item.title}
                            </div>
                            <div className={styles.badges}>{item.type}</div>
                          </div>
                        </div>
                      </div>
                    );
                  }
                }
              })
            )}
            {/* *********** */}
          </div>
        </div>
      </div>
    </>
  );
};
export default PortFolio;
